exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-show-payment .modal-dialog{max-width:768px}", ""]);

// exports
